import * as Sentry from "@sentry/nextjs";

import { isNextPublicSentryEnabled } from '@/utils/is-next-public-sentry-enabled';

const envTag = process.env.NODE_ENV === 'development' ? '-dev' : '';

export function sendToSentry(error: any, errorMsg: string | null, fingerprintCategory: string, fingerprintDetail: string, extraDetails: any = null) {
    if (!error && !errorMsg) {
        console.warn('sendToSentry called without error information to send');
        return;
    }

    if (!isNextPublicSentryEnabled()) {
        return;
    }

    const customFingerprint = ['{{ default }}', fingerprintCategory + envTag, fingerprintDetail];

    const outgoingError = error ? error : new Error(errorMsg as string);

    // optionally pass in extra info; NOTE: Max three levels deep, and max 8kb (or 256kb in certain cases).
    if (extraDetails) {
        console.log('adding Sentry context', extraDetails);

        // set this data to be sent with the error
        Sentry.setContext('extra details', extraDetails);
    }

    Sentry.captureException(
        outgoingError,
        {
            fingerprint: customFingerprint
        });

    // clear the error context, so others don't include the same data
    Sentry.getCurrentScope().clear();
};
